import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from "react-router-dom";

export const WishlistPage = ({ fetchWishlist, isLoading, wishlist, addToCart }) => {
  const navigate = useNavigate();

  useEffect(() => {
    fetchWishlist();
  }, []);

  return (
    <>
        <div className="full-row bg-light overlay-dark py-5"
            style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
            <div className="container">
            <div className="row text-center text-white">
                <div className="col-12">
                <h3 className="mb-2 text-white font-weight-bold">Wishlist</h3>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center bg-transparent">
                    <li className="breadcrumb-item">
                        <a href="#" className="text-white">Home</a>
                    </li>
                    <li className="breadcrumb-item active text-white" aria-current="page">Wishlist</li>
                    </ol>
                </nav>
                </div>
            </div>
            </div>
        </div>
        <section className="products" style={{ maxWidth: "1350px", margin: "auto", paddingTop: "30px" }}>
            <div className="container">
                <div className="row">
                    {Array.isArray(wishlist) && wishlist.map(x => {
                        let benifits = x?.Product?.benifits?.replace(/'/g, '"').trim();
                        benifits = JSON.parse(benifits || '[]');
                        return (
                            <div className="col-md-4 mb-4" key={x?.Product?.id}>
                                <div className="card" onClick={() => navigate(`/product/${x?.Product?.slug}`)}>
                                    <h3 className="product-title text-center">
                                        {x?.Product?.name}
                                    </h3>
                                    <div className="product type-product flex-grow-1 d-flex flex-column">
                                        <div className="product-wrapper d-flex flex-column flex-md-row">
                                            <div className="col-12 col-md-6 benefits-section">
                                                <div className="benefits-section">
                                                    <ul className="list-group">
                                                        {Array.isArray(benifits) && benifits.map((b, i) => {
                                                            return (
                                                                <li className="list-group-item" key={i}>
                                                                    <i className="fa-solid fa-check"></i>
                                                                    {b}
                                                                </li>
                                                            )}
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6 order-1 order-md-2 product-image">
                                                <img src={`${process.env.REACT_APP_ASSET_URL}/${x?.Product?.image}`} alt={x?.Product?.name} />
                                                <div className="icon-overlay">
                                                    <i className="fa-solid fa-cart-shopping"></i>
                                                    <i className="fa-regular fa-heart"></i> <i
                                                        className="fa-solid fa-down-left-and-up-right-to-center"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="product-price my-2">
                                            <div className="price text-center">
                                                <ins>
                                                    <span>
                                                        <span className="black-bold">Retail Price:</span>
                                                        &nbsp;₹ {x?.Product?.currentPrice}
                                                    </span>
                                                </ins>
                                            </div>
                                        </div>
                                        <div className="product-info text-center">
                                            <div className="row">
                                                <div className="col-12 col-md-6 mb-2 d-flex justify-content-center">
                                                    <a href="#" className="btn btn-outline-secondary w-100">
                                                        <i className="fa-solid fa-play"></i>&nbsp;Learn More
                                                    </a>
                                                </div>
                                                <div className="col-12 col-md-6 mb-2 d-flex justify-content-center">
                                                    <a onClick={e => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            addToCart({ProductId: x?.Product?.id, quantity: 1})
                                                        }} className="btn btn-success w-100">
                                                        <i className="fa-solid fa-cart-shopping"></i>&nbsp;Order Now
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    </>
  );
};
